__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-quick-expends/').replace(/[/]{3,}/g, "/");